import React, { lazy } from 'react';

const Login = lazy(() => import('../pages/Authentication/Login'));
const ResetPassword = lazy(() => import('../pages/Authentication/ResetPassword'));
const ForgotPassword = lazy(() => import('../pages/Authentication/ForgotPassword'));
const OtpScreen = lazy(() => import('../pages/Authentication/OtpScreen'));
const Home = lazy(() => import('../pages/Home'));
const TherapistDetails = lazy(() => import('../pages/Therapist/TherapistDetails'));
const ConsentForm = lazy(()=> import('../pages/ConsentForm'));
const MySession = lazy(()=> import('../pages/MySession'));
const AboutUs = lazy(()=> import('../pages/About'));
const Care = lazy(()=> import('../pages/Care'));
const Calendar = lazy(()=> import('../pages/Calendar/Calendar'));
const CreateSchedule = lazy(()=> import('../pages/CreateSchedule/CreateSchedule'));
const Client = lazy(() => import('../pages/Client/clients-list'));
const ClientDetails = lazy(() => import('../pages/Client/client-details'));
const NotFound = lazy(()=> import('../pages/Errors/NotFound'));

const publicRoutes = [
    { path: "/login", element: <Login />, name: 'login' },
    { path: "/reset-password/:id", element: <ResetPassword />, name: 'reset-password' },
    { path: "/otp/:id", element: <OtpScreen/>, name: 'otp'},
    { path: "/forget-password", element: <ForgotPassword/>, name: 'forget-password'},
    {
        path: "*",
        exact: true,
        element: <NotFound/>,
    }
]

const authProtectedRoutes = [
    { path: "/therapist", element: <TherapistDetails/>, name: 'therapist'},
    { path: "/home", element: <Home />, name: 'home' },
    { path: "/consent", element: <ConsentForm/>, name: 'consent' },
    { path: "/my-session", element : <MySession />, name: 'my-session'},
    { path: "/about-us", element: <AboutUs/>, name: 'about-us'},
    { path: "/Care", element: <Care/>, name: 'Care'},
    { path: "/planner", element: <Calendar/>, name: 'planner'},
    { path: "/create-schedule", element: <CreateSchedule/>, name: 'create-schedule'},
    { path: "/clients", element: <Client />, name: 'client' },
    { path: "/client/view/:clientId", element: <ClientDetails />, name: 'ClientDetails' },
    {
        path: "*",
        exact: true,
        element: <NotFound/>,
    }
];

const allRoutes = [...authProtectedRoutes, ...publicRoutes];

const isValidRoute = (path) => {
    return allRoutes.some(route => route.path === path);
};


export { authProtectedRoutes, publicRoutes, isValidRoute };